<script setup>
import { onMounted, reactive, ref, watch } from "vue";
import { timezones } from "db";
import { getErrorMessage, randHexStr } from "lib/modules/util";
import Http from "lib/modules/Http";

const props = defineProps(["cachedEmail", "readonlyEmail"]);
const emit = defineEmits(["activeComponent", "login", "update:busy", "update:cachedEmail"]);

const tz = new Intl.DateTimeFormat().resolvedOptions().timeZone;
const lang = document.documentElement.lang;
const googleBtn = ref();
const http = reactive(new Http());
const data = reactive({
	email: props.cachedEmail,
	password: null,
	persistent: true
});

function login() {
	http.post("/api/login", data, () => {
		emit("login", data.email);
	});
}

function auth(idp, token) {
	const dat = {
		timezone_id: timezones.includes(tz) ? tz : "UTC",
		lang_id: lang,
		persistent: data.persistent,
		token
	};

	http.post("/api/auth/" + idp, dat, (resp) => {
		emit("login", resp.data.email);
	});
}

watch(() => http.busy, (val) => emit("update:busy", val));

onMounted(() => {
	google.accounts.id.renderButton(googleBtn.value, {
		text: "continue_with",
		theme: "filled_black",
		size: "medium",
		locale: lang,
		width: 298
	});
});

google.accounts.id.initialize({
	client_id: "571102706236-q6jrq71tfhmin012hipksk46fut3ql1j.apps.googleusercontent.com",
	nonce: randHexStr(16),
	callback: (resp) => auth("google", resp.credential)
});
</script>

<template>
	<form @submit.prevent="login()">
		<h2>{{ $gettext("Login") }}</h2>
		<fieldset :disabled="http.busy" class="grid gap-8">
			<div class="grid gap-16">
				<UiInput
					v-model="data.email"
					v-focus="!readonlyEmail"
					:label="$gettext('E-mail')"
					:readonly="readonlyEmail"
					autocomplete="email"
					type="email"
					required
					@update:model-value="$emit('update:cachedEmail', $event)"
				/>
				<div>
					<UiInput
						v-focus="readonlyEmail"
						:value="data.password"
						:label="$gettext('Password')"
						autocomplete="current-password"
						type="password"
						required
						@input="data.password = $event.target.value"
					/>
					<a href="#" style="font-size:smaller" @click.prevent="$emit('activeComponent', 'Reset')">{{ $gettext("Forgot password?") }}</a>
				</div>
				<UiCheckbox
					v-model="data.persistent"
					:label="$gettext('Keep me logged in')"
					class="align-self-center"
				/>
			</div>
			<div class="vui-error">{{ getErrorMessage(http.error) }}</div>
			<div class="grid gap-16 justify-self-center" style="width:298px">
				<button type="submit" class="vui-btn">{{ $gettext("Login") }}</button>
				<button type="button" class="vui-btn outlined" @click="$emit('activeComponent', 'Register')">{{ $gettext("Register") }}</button>
				<div class="vui-hr-text" style="font-weight:500; font-size:0.75em; line-height:1">{{ $gettext("or") }}</div>
				<div ref="googleBtn"></div>
			</div>
		</fieldset>
	</form>
</template>
